import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { AiCommandComponent, Command } from '../command/command.component'

@Component({
  selector: 'flx-ai-command-palette',
  imports: [CommonModule, AiCommandComponent],
  templateUrl: './command-palette.component.html',
  styleUrls: ['./command-palette.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiCommandPaletteComponent {
  commands = input.required<Command[]>()
  actions = input<Command[]>()
  highlight = input<string>()
}
